import styled from 'styled-components';
import { P, fs, radius, card, eyebrow, fontMono, onPhone } from '../theme/tokens';

export const DrawerHeader = styled.header`
  background: ${P.grad};
  color: ${P.white};
  padding: 18px 22px;
`;

export const DrawerHeadRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-size: ${fs.lg}px;
  font-weight: 700;
  line-height: 1.2;
  color: ${P.white};
`;

export const DrawerSubtitle = styled.div`
  font-family: ${fontMono};
  font-size: ${fs.xs}px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 2px;
`;

export const DrawerClose = styled.button`
  margin-left: auto;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border: none;
  border-radius: ${radius.md}px;
  background: rgba(255, 255, 255, 0.16);
  color: ${P.white};
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.26);
  }
  ${onPhone} {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
  }
`;

export const DrawerStats = styled.dl`
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  margin: 16px 0 0;

  dt {
    ${eyebrow}
    color: rgba(255, 255, 255, 0.6);
  }
  dd {
    margin: 2px 0 0;
    font-size: ${fs.sm}px;
    font-weight: 600;
  }
`;

export const DrawerBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
`;

export const Section = styled.section`
  ${card}
  box-shadow: none;
  padding: 16px 18px;

  h3 {
    ${eyebrow}
    margin: 0 0 8px;
  }
`;

export const SectionText = styled.p`
  margin: 6px 0 0;
  font-size: ${fs.sm}px;
  color: ${P.muted};
  line-height: 1.55;
`;
